import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
});

export const getAdminProfileApi = async () => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/profile/view`,
      {},
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to fetch admin profile.",
    };
  }
};

export const updateAdminProfileApi = async (payload) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/profile/update`,
      {
        admin_name: payload.admin_name || "",
        admin_email: payload.admin_email || "",
      },
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to update admin profile.",
    };
  }
};

export const changeAdminPasswordApi = async (payload) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/profile/change-password`,
      {
        current_password: payload.currentPassword || "",
        new_password: payload.newPassword || "",
      },
      {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to change admin password.",
    };
  }
};